// extracted by mini-css-extract-plugin
module.exports = {"infoPanelWrap":"info-panel_infoPanelWrap__1HPKd","wrapInfoBlock":"info-panel_wrapInfoBlock__1hrtU","btnDone":"info-panel_btnDone__1S8Y5"};